export const setTokenData = ({ token }) => {
  localStorage.setItem("adminToken", token);
  // localStorage.setItem("userId", userId);
};

export const getTokenData = () => {
  const token = localStorage.getItem("adminToken");
  // const userId = localStorage.getItem("userId");
  // return { token, userId };
  return { token};
}

export const removeTokenData = () => {
  localStorage.removeItem("adminToken");
  // localStorage.removeItem("userId");
};

export const setUserData = ({ userProfileData }) => {
  localStorage.setItem("userProfileData", JSON.stringify(userProfileData));
};

export const getUserData = () => {
  const userProfileData =
    JSON.parse(localStorage.getItem("userProfileData")) || {};
  return { userProfileData };
}

export const removeUserData = () => {
  localStorage.removeItem("userProfileData");
};

// Product level List

export const setLocalProductLevel = (productLevel) => {
  localStorage.setItem("productLevel", JSON.stringify(productLevel));
};

export const getLocalProductLevel = () => {
  const productLevel = JSON.parse(localStorage.getItem("productLevel")) || [];
  return { productLevel };
};

export const removeLocalProductLevel = () => {
  localStorage.removeItem("productLevel");
};

export const removeDataLimit = () => {
  localStorage.removeItem("dataLimit");
};

export const removeStartDateFilter = () => {
  localStorage.removeItem("startDateFilter");
};

export const removeEndDateFilter = () => {
  localStorage.removeItem("endDateFilter");
};